'use client'

import { NextPage } from 'next'
import {  useRouter } from 'next/navigation'
import { useEffect } from 'react'
import { addAlert } from 'actions/alert'
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks'
import MyProfile from 'app/myProfile/page'
import { isDev } from 'app/general'

interface Props {
  children: React.ReactNode
}
const IsProfileLoaded: NextPage<Props> = ({ children }) => {
  const myProfile = useAppSelector((state) => state.profileReducer.profile)
  const status = useAppSelector((state) => state.profileReducer.status)
  const user = useAppSelector((state) => state.userReducer.user)
  const router = useRouter()
  const dispatch = useAppDispatch()

  if (isDev) console.log("IsProfileLoaded", {myProfile, user})

  useEffect(() => {
    if (!myProfile && status === "NOT_SETUP_YET" && user) {
      dispatch(addAlert({ severity: "info", message: "Please fill in your profile to enjoy all the features of brizup!" }))
      router.replace("/myProfile")
    }
  }, [myProfile])

  if (!myProfile && status === "NOT_SETUP_YET" && user) {
    return <MyProfile />
  }
  return children
}

export default IsProfileLoaded

